module.exports = __webpack_public_path__ + "static/media/maggi.a416b9bf.png";